import { createContext } from 'react';

const UserSessionModifiersContext = createContext({});

export default UserSessionModifiersContext;
